// /common/accordion.js
export function initCareerAccordion() {
  const toggles = document.querySelectorAll(".js-toggle");
  if (!toggles.length) return;

  toggles.forEach((btn, i) => {
    const panel = btn.nextElementSibling;
    if (!panel || !panel.classList.contains("js-accordion")) return;

    // --- A11y 初期化（divでもボタン相当として扱う） ---
    if (!btn.id) btn.id = `acc-toggle-${i}`;
    if (!panel.id) panel.id = `acc-panel-${i}`;
    btn.setAttribute("role", "button");
    btn.setAttribute("tabindex", "0");
    btn.setAttribute("aria-controls", panel.id);
    btn.setAttribute("aria-expanded", "false");
    panel.setAttribute("role", "region");
    panel.setAttribute("aria-labelledby", btn.id);
    panel.setAttribute("aria-hidden", "true");

    // --- 見た目の初期（閉） ---
    panel.style.overflow = "hidden";
    panel.style.height = "0px";
    panel.style.transition = "height 0.3s ease";
    btn.classList.add("is-closed");
    panel.classList.add("is-closed");

    const open = () => {
      panel.style.height = panel.scrollHeight + "px";
      const onEnd = (e) => {
        if (e.target !== panel) return;
        panel.style.height = "auto";
        panel.removeEventListener("transitionend", onEnd);
      };
      panel.addEventListener("transitionend", onEnd);

      btn.classList.add("is-open");
      btn.classList.remove("is-closed");
      panel.classList.add("is-open");
      panel.classList.remove("is-closed");
      btn.setAttribute("aria-expanded", "true");
      panel.setAttribute("aria-hidden", "false");
    };

    const close = () => {
      panel.style.height = panel.scrollHeight + "px";
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          panel.style.height = "0px";
        });
      });

      btn.classList.remove("is-open");
      btn.classList.add("is-closed");
      panel.classList.remove("is-open");
      panel.classList.add("is-closed");
      btn.setAttribute("aria-expanded", "false");
      panel.setAttribute("aria-hidden", "true");
    };

    const toggle = () => (panel.classList.contains("is-open") ? close : open)();

    // クリック
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation(); // ネスト対策
      toggle();
    });

    // キーボード（Enter / Space）
    btn.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        e.stopPropagation(); // ネスト対策
        toggle();
      }
    });
  });
}
